import { configureMonitoring } from '@fairstone-frontend/utils/core/logs';

const appEnv = process.env.REACT_APP_ENV;
const tag = process.env.NODE_ENV === 'development' ? `local-${appEnv}` : appEnv;
const whitelistUrls = ['fairstone.ca', 'amazonaws.com'];

if (process.env.NODE_ENV === 'development') {
    whitelistUrls.push('localhost');
}

configureMonitoring(process.env.REACT_APP_ATATUS_KEY, whitelistUrls, {}, tag);
